/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Builder_Model_Managed_HintInputs */



/**
* | output |
* | --- |
* | "The model is managed by this chat's agent." |
*
* @param {Agent_Builder_Model_Managed_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_builder_model_managed_hint = /** @type {((inputs?: Agent_Builder_Model_Managed_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Builder_Model_Managed_HintInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Das Modell wird vom Agenten dieses Chats verwaltet.")
	return /** @type {LocalizedString} */ ("The model is managed by this chat's agent.")
});